/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-empty-object-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/prevent-abbreviations */
import cloneDeep from 'lodash-es/cloneDeep'
import { defineStore } from 'pinia'
import { type Component, computed, type ComputedRef, markRaw, type Ref, ref, unref } from 'vue'

/**
 * vue-component-type-helpers
 * Copy from https://github.com/vuejs/language-tools/tree/master/packages/component-type-helpers
 */
export type ComponentProperties<T> = T extends new () => {
  $props: infer P
}
  ? NonNullable<P>
  : T extends (properties: infer P, ...arguments_: any) => any
    ? P
    : {}

export type MaybeWritableOrComputedRefs<TInterface extends Record<string | symbol | number, unknown>> = {
  [TInterfaceKey in keyof TInterface]: Ref<TInterface[TInterfaceKey]> | ComputedRef<TInterface[TInterfaceKey]> | TInterface[TInterfaceKey]
}

export interface DialogSettings {
  doCloneAttributes?: boolean
}

export interface DialogOptions {
  id: string
  component: any
  attributes: any
  settings?: DialogSettings
}

export const useDialogStore = defineStore('dialogs', () => {
  const items = ref<DialogOptions[]>([])

  function closeFunction(id: string): void {
    const index = items.value.findIndex((item) => item.id === id)

    if (index === -1) return

    items.value.splice(index, 1)
  }

  function open<TComponent extends Component>(
    component: TComponent,
    attributes: MaybeWritableOrComputedRefs<ComponentProperties<TComponent>>,
    settings?: DialogSettings,
  ) {
    const id = Math.ceil(Math.random() * 1_000_000_000).toString()

    const { doCloneAttributes } = settings || {}

    const newDoCloneAttributes = doCloneAttributes === undefined || doCloneAttributes

    const newAttributes = {
      // by default properties that are passed to the component will be cloned so they don't mutate the original object
      ...(newDoCloneAttributes ? cloneDeep(attributes) : attributes),

      /// when close is emitted from within the dialog
      onClickOutsideOrKeyupEscape: () => {
        attributes.onClickOutsideOrKeyupEscape ? unref(attributes?.onClickOutsideOrKeyupEscape)?.() : closeFunction(id)
      },
      onClose: () => {
        attributes.onClose ? unref(attributes?.onClose)?.() : closeFunction(id)
      },
    }

    const item = {
      id,
      component: markRaw(component),
      attributes: newAttributes,
    }

    items.value.push(item)

    return {
      close: (): void => {
        closeFunction(item.id)
      },
    }
  }

  return {
    items: computed(() => items.value),
    open,
    close,
  }
})
